import { Cancel } from '@mui/icons-material';
import { Box, Button, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ClearAllButton } from '~/components/Filter';

interface FilterFooterProps {
  handleClear: () => void;
  handleSave: () => void;
}

export const FilterFooter = ({ handleClear, handleSave }: FilterFooterProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '64px',
        width: '100%',
        padding: (theme) => theme.spacing(0, 2),
        backgroundColor: (theme) => theme.palette.common.white,
        [theme.breakpoints.down('sm')]: {
          height: '50px',
        },
      }}
    >
      <Button onClick={handleSave} sx={{ color: theme.palette.text.primary, fontSize: '12px' }}>
        {t('pages.devices.list.filters.save_filter')}
      </Button>
      <ClearAllButton onClick={handleClear} startIcon={<Cancel />}>
        {t('pages.devices.list.filters.clear_all')}
      </ClearAllButton>
    </Box>
  );
};
